import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isNanoSelector } from '../../app/selectors/appSelectors';
import Home from '../components/Home/Home';

const mapStateToProps = createStructuredSelector({ isNano: isNanoSelector });

export default connect(mapStateToProps)(Home);
